enum actionTypes {
  FETCH_PRODUCTS = 'FETCH_PRODUCTS',
  FETCH_PRODUCTS_TYPES = 'FETCH_PRODUCTS_TYPES',
  FETCH_ATTRACTIONS_CLIENT = 'FETCH_ATTRACTIONS_CLIENT',
}

export default actionTypes;
